import { ActorProfilePreviewFragmentFragment } from '@lopo-tech/lopo-api'
import * as Response from 'src/api/interfaces/responses/post'
import {
  AUTHORITY_PROFILE_TYPE,
  BLOG_PROFILE_TYPE,
  PRESS_PROFILE_TYPE, PRIVATE_PROFILE_TYPE
} from 'src/constants/profile'
import { IIngredientMarker, IMarker } from 'src/interfaces/marker'
import { IProfile, ProfileType } from 'src/interfaces/profile'

import {
  COLOR_TYPE_DEFAULT,
  COLOR_TYPE_PRIMARY,
  COLOR_TYPE_SECONDARY1,
  COLOR_TYPE_SECONDARY2,
  COLOR_TYPE_SECONDARY3,
  ColorType
} from 'src/utils/color'
import { UrlUtils } from 'src/utils/url/url'

export const getColorFromAuthorType = (author: ProfileType | ActorProfilePreviewFragmentFragment['__typename']): ColorType => {
  switch (author) {
    case 'AuthorityProfile':
    case AUTHORITY_PROFILE_TYPE:
      return COLOR_TYPE_SECONDARY2

    case 'BlogProfile':
    case BLOG_PROFILE_TYPE:
      return COLOR_TYPE_SECONDARY3

    case 'PressProfile':
    case PRESS_PROFILE_TYPE:
      return COLOR_TYPE_SECONDARY1

    case 'PrivateProfile':
    case PRIVATE_PROFILE_TYPE:
      return COLOR_TYPE_PRIMARY

    default:
      return COLOR_TYPE_DEFAULT
  }
}

export const $profileMarkers = (profile: IProfile, markers: Response.IMarker[] = []): IMarker[] => {
  return markers.map((marker, index) => ({
    color: getColorFromAuthorType(profile.type),
    id: `${profile.id}#${index}`,
    image: profile.imageUrl,
    position: {
      latitude: marker.latitude,
      longitude: marker.longitude
    },
    url: UrlUtils.getProfileFrontendPath(profile.id, profile.type)
  }))
}

export const $ingredientMarker = (json: Response.IMarker): IIngredientMarker => ({
  address: json.address_string,
  position: {
    latitude: json.latitude,
    longitude: json.longitude
  }
})
